<template>
  <div class="confirm-code">
    <Info :title="title" />

    <div class="card-box">
      <Loading message="Verificando código" v-if="checking" />

      <template v-else>
        <form
          v-if="data.verified"
          @submit="
            $event.preventDefault()
            $emit('skip')
          "
        >
          <p>Código verificado com sucesso.</p>

          <ContinueSection enable-back @back="$emit('back')" />
        </form>

        <template v-else>
          <h3>
            <p class="texto_confirmacao">
              Por favor, informe o código que enviamos para você por
              {{ data.type === 'email' ? 'e-mail' : 'SMS' }}.
              <br />
              <strong>{{ data.resource }}</strong>
            </p>
          </h3>

          <form @submit="submitHandler">
            <div class="linha">
              <div class="codigo_sms">
                <input
                  type="text"
                  placeholder="Digite o código aqui"
                  :value="data.code"
                  @change="changeCodeHandler"
                />
              </div>
            </div>

            <div class="erroDados" v-if="invalid">
              Código de verificação inválido
            </div>

            <ContinueSection @skip="$emit('skip')" @back="$emit('back')" />
          </form>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Info from '@/components/Info'
import Loading from '@/components/Loading'
import ContinueSection from '@/components/ContinueSection'
import { verifyEmail, verifySms } from '@/common/lib/api'

export default {
  name: 'ConfirmCode',
  components: {
    ContinueSection,
    Loading,
    Info
  },
  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    title: String,
    accountId: String,
    data: Object
  },
  data: () => ({
    checking: false,
    invalid: false
  }),
  methods: {
    change(partial) {
      this.$emit('change', {
        ...this.data,
        ...partial
      })
    },
    changeCodeHandler(e) {
      this.change({ code: e.target.value })
    },
    async submitHandler(e) {
      e.preventDefault()

      this.checking = true

      const { accountId, data } = this
      const { type, code } = data
      const { verified } = type === 'email'
        ? await verifyEmail(accountId, code)
        : await verifySms(accountId, code)

      this.invalid = !verified

      if (verified) {
        this.change({ verified: true })
      }

      this.checking = false
    }
  }
}
</script>

<style scoped></style>
